import React from 'react';

export type VideoProps = {
  id?: string;
  onReplay?: () => void;
  onClose?: () => void;
  isFullScreen?: boolean;
};

export type IVideoOverlayProvider = {
  renderOverlay?: (videoProps: VideoProps) => React.ReactNode;
};

const VideoOverlayContext = React.createContext<IVideoOverlayProvider>({});

export const VideoOverlayProvider: React.FC<React.PropsWithChildren<IVideoOverlayProvider>> = ({
  children,
  renderOverlay,
}) => {
  return (
    <VideoOverlayContext.Provider value={{ renderOverlay }}>
      {children}
    </VideoOverlayContext.Provider>
  );
};

export const useVideoOverlayContext = () => {
  return React.useContext(VideoOverlayContext);
};
